var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroku(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#430098",
      fillOpacity: 1
    },
    d: "M56.7 0A6.3 6.3 0 0 1 63 6.3v57.4a6.3 6.3 0 0 1-6.3 6.3H6.3A6.3 6.3 0 0 1 0 63.7V6.3A6.3 6.3 0 0 1 6.3 0Zm0 3.5H6.3a2.803 2.803 0 0 0-2.8 2.8v57.4c0 1.542 1.258 2.8 2.8 2.8h50.4c1.546 0 2.8-1.258 2.8-2.8V6.3a2.8 2.8 0 0 0-2.8-2.8Zm-40.075 42 7.875 7-7.875 7Zm7-35v19.871C27.121 29.234 32.004 28 36.75 28c4.328 0 6.918 1.7 8.328 3.129 2.883 2.918 3.043 6.601 3.047 7.297V59.5h-7V38.598C41.09 36.96 40.305 35 36.75 35c-6.797 0-14.387 3.266-15.121 3.59l-.059.027-4.945 2.238V10.5Zm24.5 0c-.473 3.977-2.086 7.79-5.25 11.375h-7c2.75-3.61 4.477-7.406 5.25-11.375Zm0 0"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.363c95b0b5e0c53ec21835f3bbc5ac36.svg";
export { ForwardRef as ReactComponent };